import React, { Component, Fragment } from 'react';
import { NavLink } from 'redux-first-router-link'; 

export default class Nav extends Component {

	render() {
		const { page } = this.props;
		const className = `${page}-nav`
	    return (
	    	<nav className={className}>
				<NavLink className="nav-link" to="/20-in-20"><img src="https://static.cdn.gallerymediagroup.com/citi20in20/icons/arrow-long-left.svg" /> Home</NavLink>
				{page !== 'honorees' &&
				<NavLink className="nav-link" to="/20-in-20/honorees">All Honorees</NavLink>
				}
				{page !== 'committee' &&
				<NavLink className="nav-link" to="/20-in-20/committee">Meet the Committee</NavLink>
				}
		    </nav>
	    );
	}
}